module.exports = __webpack_public_path__ + "25162bf857a8eb83ea932a58436e1049.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/ui-icons_2e83ff_256x240.png
// module id = 485
// module chunks = 2